<template>
  <tr>
    <td class="text-xs-center px-0" style="padding-right: 0px; padding-left: 0px; width: 0">
        <v-tooltip :color="props.item.pendente ? 'warning' : ( props.item.consolidada ? 'success' : 'error')" top>
          <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-icon :color="props.item.pendente ? 'warning' : ( props.item.consolidada ? 'success' : 'error')">{{ props.item.pendente ? 'access_alarms' : (props.item.consolidada ? 'check_circle' : 'error')}} </v-icon>
              </span>
          </template>
          <span>Consolidado</span>
      </v-tooltip>
    </td>
    <td class="px-0">{{ props.item.data_compra }}</td>
    <td class="text-truncate">
      <v-layout justify-center column>
        <v-flex pa-0 >
          <v-tooltip v-if="props.item.cliente" dark color="black" top>
              <template v-slot:activator="{ on }">
                  <span v-on="on">
                      {{ props.item.cliente.nome | truncate(20) }}
                  </span>
              </template>
              <span>{{ props.item.cliente.nome }} {{ props.item.cliente.sobrenome }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex  pa-0 v-if="props.item.num_cartao || props.item.cartao">
          <strong>{{props.item.num_cartao || (props.item.cartao && props.item.cartao.numero)}}</strong>
        </v-flex>
      </v-layout>
    </td>
    <td class="text-xs-left">
      <v-layout justify-center column>
        <v-flex pa-0>
          {{ props.item.tid }}
        </v-flex>
        <v-flex  pa-0>
          <strong>NSU: {{ props.item.nsu || "INDEFINIDO" }}</strong>
        </v-flex>
      </v-layout>
    </td>
    <td class="text-xs-right  px-0">{{ props.item.valor }}</td>
    <td class="justify-center layout px-0" style="padding-right: 0px; padding-left: 0px;">
      <v-tooltip v-if="props.item.combustivel" :color="props.item.combustivel.color" top>
          <template v-slot:activator="{ on }">
              <span v-on="on">
                  <svg-filler :path="require(`@/assets/combs/${props.item.combustivel.icone}.svg`)" width="40px" height="40px" :fill="'grey'"/>
              </span>
          </template>
          <span>{{props.item.combustivel.nome}}</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['props'],
  mounted () {
    this.$root.$on('saveDataConsolidacaoPagamento', () => {
      if (this.props.item.pendente) {
        this.$store.dispatch('saveDataConsolidacaoPagamento', {
          id_compra: this.props.item.reference,
          num_cartao: this.props.item.cartao ? this.props.item.cartao.numero : 'não informado',
          nsu: this.props.item.nsu
        }).then(() => {
          let item = { ...this.props.item, num_cartao: (this.props.item.cartao ? this.props.item.cartao.numero : 'não informado'), nsu: this.props.item.nsu, consolidada: true, pendente: false }
          this.$emit('setItem', { element: item, index: this.props.index })
        })
      }
      // if (this.props.item.pendente) {
      //   let item = { ...this.props.item, num_cartao: this.props.item.cartao.numero, nsu: this.props.item.nsu, consolidada: true, pendente: false }
      //   this.$emit('setItem', { element: item, index: this.props.index })
      // }
    })
  }
}
</script>
